<template>
    <div class="betslip-selection__list responsive__element">
        <div class="betslip-selection__list-wrapper">
            <div
                v-for="(event, i) in events"
                :key="i"
                class="betslip-selection__item"
            >
                <div
                    class="selection-row"
                >
                    <div class="selection-row__wrapper">
                        <div class="event-summary">
                            <div class="event-summary__match-indicator-wrapper">
                                <span class="event-summary__match-indicator-day" >
                                    {{ event.date | formatDateTime('ddmm') }}
                                </span>
                                <span class="event-summary__match-indicator-time">{{ event.date | timeOnly }}</span>
                            </div>
                            <div class="event-summary__competitors-and-scores">
                                <div class="event-summary__competitors-wrapper">
                                    <span class="event-summary__competitors-team1" :title="event.name">
                                        {{ event.name }}
                                    </span>
                                    <span class="event-summary__competitors-team2">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="selection-row__controls">
                    </div>
                    <div
                        class="selection-row__bet"
                        :class="statusClass(event)"
                    >
                        <div class="selection-row__market-box">
                            <span
                                v-if="event.eventNo !== '/'"
                                class="selection-row__system-info"
                            >
                                {{ event.eventNo }}
                            </span>
                            <span class="selection-row__fix-switch">
                                <slot />
                            </span>
                            <span
                                class="selection-row__market-name"
                                :title="event.odd.marketName"
                            >
                                {{ event.odd.marketName || event.odd.name }}
                            </span>
                        </div>
                        <button class="pick">
                            <span
                                class="market actionable"
                                :title="event.odd.symbol"
                            >
                                {{ event.odd.symbol }}
                                {{ event.odd.specialBetValue ? `(${event.odd.specialBetValue})` : '' }}
                            </span>
                            <span class="odd">
                                <span
                                    v-if="isRefund(event)"
                                    class="odd--refunded"
                                >
                                    {{ event.odd.coefficient | twoDecimals }}
                                </span>
                                <template v-if="isRefund(event)">1</template>
                                <template v-else>
                                    {{ event.odd.coefficient | twoDecimals }}
                                </template>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventStatus } from '@core/models/tickets/enums';

    export default {
        name: 'OfflineVirtualTickets',
        props: {
            events: {
                type: Array,
            },
        },
        methods: {
            statusClass(eventStatus) {
                switch (eventStatus.status) {
                    case EventStatus.win:
                        return 'selection-row__bet--won';
                    case EventStatus.lost:
                        return 'selection-row__bet--lost';
                    case EventStatus.refund:
                        return 'selection-row__bet--refund';
                    default:
                        return '';
                }
            },
            isRefund(eventRefund) {
                return eventRefund.status === EventStatus.refund;
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/tickets/OfflineVirtualTickets.vue